"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropertyTypesOptions = exports.PropertyTypesOptionsContextProvider = exports.PropertyTypesOptionsContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.PropertyTypesOptionsContext = (0, react_1.createContext)(null);
const PropertyTypesOptionsContextProvider = ({ children, propertyTypeOptions, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.PropertyTypesOptionsContext.Provider, { value: propertyTypeOptions, children: children }));
};
exports.PropertyTypesOptionsContextProvider = PropertyTypesOptionsContextProvider;
const usePropertyTypesOptions = () => {
    const propertyTypesOptions = (0, react_1.useContext)(exports.PropertyTypesOptionsContext);
    if (!propertyTypesOptions) {
        throw new Error("no PropertyTypesOptionsContext value has been provided");
    }
    return propertyTypesOptions;
};
exports.usePropertyTypesOptions = usePropertyTypesOptions;
